// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppointmentSlotPickerController from "./appointment_slot_picker_controller"
application.register("appointment-slot-picker", AppointmentSlotPickerController)

import BodyComparisonController from "./body_comparison_controller"
application.register("body-comparison", BodyComparisonController)

import Bridge__FormController from "./bridge/form_controller"
application.register("bridge--form", Bridge__FormController)

import Bridge__MenuController from "./bridge/menu_controller"
application.register("bridge--menu", Bridge__MenuController)

import Bridge__NavButtonController from "./bridge/nav_button_controller"
application.register("bridge--nav-button", Bridge__NavButtonController)

import ChartsController from "./charts_controller"
application.register("charts", ChartsController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DailyGoalsController from "./daily_goals_controller"
application.register("daily-goals", DailyGoalsController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DirectUploadsController from "./direct_uploads_controller"
application.register("direct-uploads", DirectUploadsController)

import DocumentsFormController from "./documents_form_controller"
application.register("documents-form", DocumentsFormController)

import FeedbackFormController from "./feedback_form_controller"
application.register("feedback-form", FeedbackFormController)

import FeedbackGoalModalController from "./feedback_goal_modal_controller"
application.register("feedback-goal-modal", FeedbackGoalModalController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import Frontend__NavController from "./frontend/nav_controller"
application.register("frontend--nav", Frontend__NavController)

import GoalCompletionController from "./goal_completion_controller"
application.register("goal-completion", GoalCompletionController)

import GroupMembersController from "./group_members_controller"
application.register("group-members", GroupMembersController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import KpiController from "./kpi_controller"
application.register("kpi", KpiController)

import LazyFormController from "./lazy_form_controller"
application.register("lazy-form", LazyFormController)

import MealController from "./meal_controller"
application.register("meal", MealController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import NutritionalPreviewController from "./nutritional_preview_controller"
application.register("nutritional-preview", NutritionalPreviewController)

import OpenConsumableModalController from "./open_consumable_modal_controller"
application.register("open-consumable-modal", OpenConsumableModalController)

import ProfilesController from "./profiles_controller"
application.register("profiles", ProfilesController)

import SlotSelectionController from "./slot_selection_controller"
application.register("slot-selection", SlotSelectionController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
